export default "__VITE_ASSET__017656c7__"